/* eslint-disable no-undef */
import Vue from 'vue'
import api from '../api'
import sha1 from 'sha1'
import JSEncrypt from 'encryptlong'
export const USER_SIGNIN = 'USER_SIGNIN' // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录

function init () {
  let state = JSON.parse(sessionStorage.getItem('user'))
  if (state) {
    window.permissions = state.permissions
    return state
  }
  return {}
}

export default {
  state: init(),
  mutations: {
    [USER_SIGNIN] (state, user) {
      window.permissions = user.permissions
      // TODO test code
      // window.permissions['bus_finace_report'] = ['c', 'r', 'u', 'd']
      // window.permissions['bus_purchasing_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['patient_order_stat'] = ['c', 'r', 'u', 'd']
      // window.permissions['base_dishes'] = ['c', 'r', 'u', 'd']
      // window.permissions['patient_beds'] = ['c', 'r', 'u', 'd']
      // window.permissions['advice_manage'] = ['c', 'r', 'u', 'd']
      // window.permissions['name_dish_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['template_dish_arrangement2'] = ['c', 'r', 'u', 'd']
      // window.permissions['name_template_detail'] = ['c', 'r', 'u', 'd']
      // window.permissions['recharge_setting'] = ['c', 'r', 'u', 'd']
      // window.permissions['subscriber_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['delayUploadOrders_search'] = ['c', 'r', 'u', 'd']
      // window.permissions['upload_img'] = ['c', 'r', 'u', 'd']
      // window.permissions['subside_operate2'] = ['c', 'r', 'u', 'd']
      // window.permissions['relief_statics'] = ['c', 'r', 'u', 'd']
      // window.permissions['random_discount_setting'] = ['c', 'r', 'u', 'd']
      // window.permissions['stall_setting'] = ['c', 'r', 'u', 'd']
      // window.permissions['discount_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['monthly_statistical_statement'] = ['c', 'r', 'u', 'd']
      window.permissions['cooking_list_detail'] = ['c', 'r', 'u', 'd']
      if (user.type == 1) {
        window.permissions['certificate_management'] = ['c', 'r', 'u', 'd']
      }
      window.permissions['refund_statics'] = ['c', 'r', 'u', 'd']
      window.permissions['poundage_list'] = ['c', 'r', 'u', 'd']

      window.permissions['fingerprint_list'] = ['c', 'r', 'u', 'd']
      window.permissions['asyn_list'] = ['c', 'r', 'u', 'd']
      window.permissions['outPayTradeNo_query'] = ['c', 'r', 'u', 'd']
      window.permissions['health_query'] = ['c', 'r', 'u', 'd']
      if (user.companyId === 565 || user.companyId === 708) {
        window.permissions['fast_recharge'] = ['c', 'r', 'u', 'd']
      }
      if (user.companyId === 627 || user.companyId === 212) {
        window.permissions['withdrawal_list'] = ['c', 'r', 'u', 'd']
      }
      // window.permissions['face_list'] = ['c', 'r', 'u', 'd']
      window.permissions['cash_print'] = ['c', 'r', 'u', 'd']
      window.permissions['subscriber_listxcc'] = ['c', 'r', 'u', 'd']
      if (user.companyId === 212 || user.companyId === 533) {
        window.permissions['administrator_takesmeal'] = ['c', 'r', 'u', 'd']
      }
      // window.permissions['discount_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['usergroup_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['autopay_list'] = ['c', 'r', 'u', 'd']
      // window.permissions['withdrawals'] = ['c', 'r', 'u', 'd']
      sessionStorage.setItem('user', JSON.stringify(user))
      Object.assign(state, user)
    },
    [USER_SIGNOUT] (state) {
      window.permissions = {}
      sessionStorage.removeItem('user')
      Object.keys(state).forEach(k => Vue.delete(state, k))
    }
  },
  actions: {
    [USER_SIGNIN] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        var encryptor = new JSEncrypt() // 创建加密对象实例
        // 之前ssl生成的公钥，复制的时候要小心不要有空格
        var pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCUmFLuydmxpTm61paWkbwyqy03zAAiWBYqLLDfWGdC1qdyMkrQ8oernO2o2MhUA4KeqzYg2dbyS8lz/9kMbRDP1icVsaQjzjoJ+ld0ajZfnWkkTVfb5xhhzlkS2fTZLtttGhgpVuHJdHAmH/0+wYiA3u6lVV6cDLfpJqOrKq/2MQIDAQAB'
        encryptor.setPublicKey(pubKey)// 设置公钥
        user.auth = encryptor.encryptLong(user.auth)
        api.login(user).then((data) => {
          commit(USER_SIGNIN, data)
          resolve()
        }, (data) => {
          commit(USER_SIGNOUT)
          reject(data)
        })
      })
    },
    [USER_SIGNOUT] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.logout(user).then(() => {
          commit(USER_SIGNOUT)
          resolve()
        }, (data) => {
          commit(USER_SIGNOUT)
          resolve()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js